import { MeasurementUnit } from '@ml/services/types/service';

export class TaskBilling {
  measurementUnits: MeasurementUnit[];
  hourlyRate: number;
}
